import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { initYaMaps } from 'vpl.tas';


export const ProjectsDetailPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number],
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    data() {
        return {
            shareObj: false
        }
    },
    methods: {
        zoomClick() {
            $(this.$el).find('.swiper-slide-active').find('a').trigger('click');
        },
        initMap() {

            this.map = new ymaps.Map("city-map", {
                center: ['45.356210', '36.467332'],
                zoom: 15,
                behaviors: ['default'],
                controls: []
            });

            this.map.behaviors.disable(['scrollZoom']);
            this.setMapItems(this.struct[this.structKey].componentData.MAP_ELEMS);

            this.map.controls.add('zoomControl', {
                size: 'small',
                float: 'none',
                position: {
                    top: $('#city-map').height() / 2 - 30,
                    right: '45px'
                }
            });
            self = this;
            let zoomRangeRatio = $(window).width() < 768 ? 30 : 100;
            this.map.setBounds(this.map.geoObjects.getBounds(),
                { checkZoomRange: true, zoomMargin: zoomRangeRatio }).then(function () { if (self.map.getZoom() > 14) self.map.setZoom(14); });
        },
        setMapItems(mapItems) {
            var markers = [];
            var data = [];

            for (let i in mapItems) {
                let mapitem = mapItems[i];
                markers.push([mapitem.LAT, mapitem.LON]);

                data.push({
                    "NAME": mapitem.NAME,
                    "PROPERTY_ADDRESS_CITY": mapitem.PROPERTY_CITY_VALUE,
                    "PROPERTY_ADDRESS_TYPE": mapitem.PROPERTY_TYPE_VALUE,
                    "ID": mapitem.ID,
                    "CITY": mapitem.PROPERTY_CITY_VALUE,
                    "LINK": mapitem.DETAIL_PAGE_URL
                });
            }

            this.map.geoObjects.each((geoObject) => {
                if (geoObject instanceof ymaps.ObjectManager) {
                    this.map.geoObjects.remove(geoObject);
                }
            });

            this.objectManager = new ymaps.ObjectManager({
                clusterize: true,
                clusterIcons: [
                    {
                        href: this.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                        size: [40, 40],
                        offset: [-27.5, -42],
                        iconContentOffset: [23, 15],
                    },
                    {
                        href: this.SITE_TEMPLATE_PATH + '/img/svg/claster-small.svg',
                        size: [55, 55],
                        offset: [-27.5, -42],
                        iconContentOffset: [25, 25],
                    }],
                clusterNumbers: [3],
                clusterIconContentLayout: ymaps.templateLayoutFactory.createClass('<span style="font-weight: 600;font-size: 18px; color: #000">{{ properties.geoObjects.length }}</span>')
            });


            var MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
                '<div class="popover">' +
                '<div class="popover__arrow"></div>' +
                '<div class="popover__inner">' +
                '<a class="popover__close" href="#">' +
                '<svg class="icon icon-close">' +
                '<use xlink:href="#icon-close"></use>' +
                '</svg>' +
                '</a>' +
                '$[[options.contentLayout observeSize minWidth=300 maxWidth=480]]' +
                '<span class="popover__tail"></span>' +
                '</div>' +
                '</div>', {
                build: function () {
                    this.constructor.superclass.build.call(this);

                    this._$element = $('.popover', this.getParentElement());

                    this.applyElementOffset();

                    this._$element.find('.popover__close')
                        .on('click', $.proxy(this.onCloseClick, this));
                },
                clear: function () {
                    this._$element.find('.popover__close')
                        .off('click');

                    this.constructor.superclass.clear.call(this);
                },
                onSublayoutSizeChange: function () {
                    MyBalloonLayout.superclass.onSublayoutSizeChange.apply(this, arguments);

                    if (!this._isElement(this._$element)) {
                        return;
                    }

                    this.applyElementOffset();

                    this.events.fire('shapechange');
                },
                applyElementOffset: function () {
                    this._$element.css({
                        left: -(this._$element[0].offsetWidth / 2.45),
                        top: -(this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight - 35)
                    });
                },
                onCloseClick: function (e) {
                    e.preventDefault();

                    this.events.fire('userclose');
                },
                getShape: function () {
                    if (!this._isElement(this._$element)) {
                        return MyBalloonLayout.superclass.getShape.call(this);
                    }

                    var position = this._$element.position();

                    return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                        [position.left, position.top], [
                            position.left + this._$element[0].offsetWidth,
                            position.top + this._$element[0].offsetHeight + this._$element.find('.popover__arrow')[0].offsetHeight
                        ]
                    ]));
                },
                _isElement: function (element) {
                    return element && element[0] && element.find('.popover__arrow')[0];
                }
            });

            var collection = {
                type: "FeatureCollection",
                features: []
            };

            for (var i = 0; i < markers.length; i++) {
                var marker = markers[i];
                var item = data[i];

                var balloon = `
                <div class="ballon">
                        <div class="ballon__head">
                        <div class="baloon__head-text">
                            ${data[i].NAME}
                        </div>
                    </div>
                    <div class="baloon__body baloon__body--projects">
                        <div class="baloon__props">
                                <div style="${data[i].PROPERTY_ADDRESS_TYPE ? '' : 'display:none'}" class="baloon__line">
                                    <span class="baloon__props-title">Тип объекта</span>
                                    <span>${item.PROPERTY_ADDRESS_TYPE}</span>
                            </div>
                                <div style="${data[i].PROPERTY_ADDRESS_CITY ? '' : 'display:none'}" class="baloon__line">
                                    <span class="baloon__props-title">город</span>
                                    <span class="baloon__props-city">${item.PROPERTY_ADDRESS_CITY}</span>
                            </div>
                        </div>
                        <div class="baloon__props-btn">
                            <a href="${data[i].LINK}" class="btn btn--border">Подробнее</a>
                        </div>
                    </div>
                </div>
                `;

                collection.features.push({
                    type: 'Feature',
                    id: i,
                    geometry: {
                        type: 'Point',
                        coordinates: marker
                    },
                    properties: {
                        balloonContent: balloon,
                        hintContent: item.NAME,
                        id: item.ID,
                        city: item.CITY
                    },
                    options: {
                        balloonLayout: MyBalloonLayout,
                        balloonContentLayout: ymaps.templateLayoutFactory.createClass('<div class="popover__content">$[properties.balloonContent]</div>'),
                        balloonOffset: [83, -35],
                        iconColor: '#CE6B33',
                        iconLayout: 'default#imageWithContent',
                        iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka.svg',
                        iconImageSize: [44, 53],
                        iconImageOffset: [-22, -53],
                        iconContentOffset: [0, 0],
                    }
                }
                )
            }

            this.objectManager.add(collection);

            this.map.geoObjects.add(this.objectManager);

            this.objectManager.objects.events.add(['mouseenter', 'mouseleave'], (e) => {
                var objectId = e.get('objectId');
                if (e.get('type') == 'mouseenter') {
                    this.objectManager.objects.setObjectOptions(objectId, {
                        iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka-h.svg'
                    });
                } else {
                    this.objectManager.objects.setObjectOptions(objectId, {
                        iconImageHref: this.SITE_TEMPLATE_PATH + '/img/svg/metka.svg'
                    });
                }
            });
            //   self = this;
            // let zoomRangeRatio =  $(window).width() < 768 ? 30 : 100;
            // this.map.setBounds(this.map.geoObjects.getBounds(),
            //     {checkZoomRange:true, zoomMargin:100}).then(function(){ if(self.map.getZoom() > 14) self.map.setZoom(14);});
        },
        setCityFilter(event) {
            let city = $(event.target).val();
            city ? this.objectManager.setFilter(`properties.city == ${'"' + city + '"'}`) : this.objectManager.setFilter();
            self = this;
            let zoomRangeRatio = $(window).width() < 768 ? 30 : 100;
            this.map.setBounds(this.map.geoObjects.getBounds(),
                { checkZoomRange: true, zoomMargin: zoomRangeRatio }).then(function () { if (self.map.getZoom() > 14) self.map.setZoom(14); });
        },
        share(e) {
            /*
            if(this.shareObj == false){
              this.shareObj = Ya.share2($(e.target).find('.ya-share2')[0], {
                theme: {
                  services: 'vkontakte,odnoklassniki,telegram,twitter,whatsapp,pinterest',
                  size: 'm',
                  colorScheme: "whiteblack",
                  popupPosition: 'inner',
                  useLinks: true,
                  direction: 'horizontal'
                },
                content: {
                    url: window.location.origin + this.item.DETAIL_PAGE_URL,
                    title: this.item.NAME,
                    description: this.item.PREVIEW_TEXT,
                    image: window.location.origin + this.item.PREVIEW_IMAGE
                }
              });
            }
            */
            let link = $(e.target);
            if (!link.hasClass('is-active')) {
                link.addClass('is-active');
                link.find('.js-share-inner').addClass('is-open');
            } else {
                link.removeClass('is-active');
                link.find('.js-share-inner').removeClass('is-open');
            }

        },
        shareClick(e, type) {
            e.stopPropagation();

            let pageUrl = window.location.origin + window.location.pathname;
            const pageTitle = encodeURIComponent(document.title);

            switch (type) {
                case 'wa':
                    window.open(`https://wa.me/?text=${pageTitle}%20${pageUrl}`, '_blank').focus();
                    break;
                case 'tg':
                    window.open(`https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`, '_blank').focus();
                    break;
                case 'vk':
                    window.open("https://vk.com/share.php?url=" + pageUrl, '_blank').focus();
                    break;
                case 'copy':

                    try {
                        navigator.clipboard.writeText(pageUrl);
                        alert('Ссылка скопирована в буфер обмена');
                    } catch (err) {
                        const textArea = document.createElement('textarea');
                        textArea.value = pageUrl;
                        document.body.appendChild(textArea);
                        textArea.select();

                        try {
                            document.execCommand('copy');
                            alert('Ссылка скопирована в буфер обмена');
                        } catch (err) {
                            alert('Не удалось скопировать ссылку');
                        }

                        document.body.removeChild(textArea);
                    }

                    break;
            }

            // window.open("https://vk.com/share.php?url=" + window.location.origin + window.location.pathname,"sharer","status=0,toolbar=0,width=650,height=500")

        },
    },
    mounted() {

        let sliderParams = {
            loop: true,
            spaceBetween: 10,
            grabCursor: true,
        }

        if (this.struct[this.structKey].componentData.ITEM.GALLERY.length > 1) {
            let prodjSliderNav = new Swiper($(this.$el).find(".js-projects-detail-nav")[0], {
                loop: true,
                spaceBetween: 12,
                slidesPerView: 7,
                grabCursor: true,
                watchSlidesProgress: true,
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 9
                    },
                    1200: {
                        slidesPerView: 7,
                        spaceBetween: 12
                    }
                }
            });

            sliderParams['thumbs'] = {
                swiper: prodjSliderNav
            };
            sliderParams['pagination'] = {
                el: ".js-projects-detail-pag",
                type: "bullets",
                clickable: true
            };
            sliderParams['navigation'] = {
                nextEl: ".js-projects-detail-next",
                prevEl: ".js-projects-detail-prev"
            };
        }

        let prodjSliderMain = new Swiper($(this.$el).find(".js-projects-detail-main")[0], sliderParams);


        initYaMaps();

        let interval = setInterval(()=>{
            if(typeof ymaps !== "undefined"){
                ymaps.ready(() => {
                    this.initMap();
                });

                clearInterval(interval);
            }
        }, 500);

        $(this.$el).find('.js-city-filter').niceSelect();
        $(this.$el).find('.js-city-filter').change((e) => this.setCityFilter(e));

        $(this.$el).find('[data-fancybox]').fancybox({
            loop: true,
        });
        $(".js-list-close").on("click", function () {
            $('.js-city-filter').removeClass('open');
        });
    },
    template: `
<div style="display: contents;">
    <section class="section section--first">
        <div class="container">
            <div class="projects__detail">
                 <div class="product-detail__share js-share" @click="share($event)">
                    <svg class="icon icon-share"><use xlink:href="#icon-share"></use></svg>
                    Поделиться проектом
                    <div class="product-detail__share-inner js-share-inner">
                        <a class="product-detail__share-inner-item"
                                        @click.prevent="shareClick($event, 'wa')"
                                        title="">
                                        <svg class="ico ico-wa" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-wa"></use></svg>
                                </a>
                                <a class="product-detail__share-inner-item"
                                        @click.prevent="shareClick($event, 'tg')"
                                        title="">
                                        <svg class="ico ico-tg" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-tg"></use></svg>
                                </a>
                                <a class="product-detail__share-inner-item"
                                        @click.prevent="shareClick($event, 'vk')"
                                        title="">
                                        <svg class="ico ico-vk" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-vk"></use></svg>
                                </a>
                                <a class="product-detail__share-inner-item"
                                        @click.prevent="shareClick($event, 'copy')"
                                        title="">
                                        <svg class="ico ico-copy" width="24" height="24" aria-hidden="true"><use xlink:href="#ico-copy"></use></svg>
                                </a>
                    </div>
                </div>
                <div class="projects__detail-top js-proj-det-wp">
                    <div class="projects__detail-slider-wp">
                        <a href="#" class="zoom" @click.prevent="zoomClick()">
                            <svg class="icon icon-zoom"><use xlink:href="#icon-zoom"></use></svg>
                        </a>
                        <div class="swiper projects__detail-slider js-projects-detail-main">
                            <div class="swiper-wrapper">
                                <template v-for="galItem in this.struct[this.structKey].componentData.ITEM.GALLERY">
                                    <div v-if="galItem.TYPE == 'photo'" class="swiper-slide">
                                        <a :href="galItem.BIG" class="projects__detail-slider-img" data-fancybox="projects-detail">
                                            <img :src="galItem.MEDIUM" :alt="this.struct[this.structKey].componentData.ITEM.NAME" :title="this.struct[this.structKey].componentData.ITEM.NAME" loading="lazy">
                                        </a>
                                    </div>
                                    <div v-else class="swiper-slide">
                                        <a :href="galItem.SRC" class="projects__detail-slider-img" data-fancybox="projects-detail">
                                            <video preload="metadata" playsinline="" webkit-playsinline="" loop="" muted="">
                                                <source :src="galItem.SRC" :type="galItem.FILE_TYPE">
                                            </video>
                                            <span class="projects__detail-slider-img-icon">
                                                <svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg>
                                            </span>
                                        </a>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div v-if="this.struct[this.structKey].componentData.ITEM.GALLERY.length > 1" class="swiper-pagination js-projects-detail-pag"></div>
                    <div class="projects__detail-tags">
                        <div v-if="this.struct[this.structKey].componentData.ITEM.TYPE" class="projects__detail-tags-item">
                            <span>Тип объекта</span>
                            {{this.struct[this.structKey].componentData.ITEM.TYPE}}
                        </div>
                        <div v-if="this.struct[this.structKey].componentData.ITEM.CITY" class="projects__detail-tags-item">
                            <span>Город</span>
                            {{this.struct[this.structKey].componentData.ITEM.CITY}}
                        </div>
                    </div>
                    <a href="#" data-toggle="modal" data-target="#order" class="btn btn--green projects__detail-btn">Нужен похожий проект?</a>
                </div>
                <div v-if="this.struct[this.structKey].componentData.ITEM.GALLERY.length > 1" class="projects__detail-bottom">
                    <div class="swiper projects__detail-slider-nav js-projects-detail-nav">
                        <div class="swiper-wrapper">
                            <template v-for="galItem in this.struct[this.structKey].componentData.ITEM.GALLERY">
                                <div v-if="galItem.TYPE == 'photo'" class="swiper-slide">
                                    <div class="projects__detail-slider-nav-img">
                                        <img :src="galItem.SMALL" :alt="this.struct[this.structKey].componentData.ITEM.NAME" :title="this.struct[this.structKey].componentData.ITEM.NAME" loading="lazy">
                                    </div>
                                </div>
                                <div v-else class="swiper-slide">
                                    <div class="projects__detail-slider-nav-img">
                                        <img :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="this.struct[this.structKey].componentData.ITEM.NAME" :title="this.struct[this.structKey].componentData.ITEM.NAME" loading="lazy">
                                        <span class="projects__detail-slider-img-icon">
                                            <svg class="icon icon-play"><use xlink:href="#icon-play"></use></svg>
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="section__nav-arrows">
                        <div class="swiper-button-prev slider-btn js-projects-detail-prev">
                            <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                        </div>
                        <div class="swiper-button-next slider-btn js-projects-detail-next">
                            <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section v-if="this.struct[this.structKey].componentData.ITEM.TEXT" class="section section--gray">
        <div class="container">
            <div class="text-block content" v-html="this.struct[this.structKey].componentData.ITEM.TEXT">
            </div>
        </div>
    </section>
    <section v-if="this.struct[this.structKey].componentData.MAP_ELEMS" class="section project-map">
        <div class="container">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Проекты на карте
                    </h2>
                </div>
                <div class="section__nav">
                    <div class="sort__select-wp">
                        <select name="" id="" class="sort__select js-city-filter">
                            <option value="">Все города</option>
                            <option v-for="city in this.struct[this.structKey].componentData.CITY" :value="city">{{city}}</option>
                        </select>
                        <div class="catalog__overlay js-catalog-overlay"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="city__map js-city-map" id="city-map"></div>
    </section>
    <section v-if="this.struct[this.structKey].componentData.ITEM.BRANDS.length" class="section section--first">
        <div class="container">
            <div class="section__heading">
                <div class="section__title-wp">
                    <h2 class="section__title">
                        Оборудование в проекте
                    </h2>
                </div>
            </div>
            <div class="project-brands">
                <a v-for="brand in this.struct[this.structKey].componentData.ITEM.BRANDS" :href="brand.LINK" class="clients__card">
                    <img class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="brand.FILE" :alt="brand.NAME" :title="brand.NAME">
                </a>
            </div>
        </div>
    </section>
</div>
    `
}